import { useEffect } from 'react';

import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useGetListDocumentTypeQuery } from 'services/talento';

interface DocumentTypeSelectProps extends Omit<SelectProps, 'options'> {
  country: string;
}

export function DocumentTypeSelect({ country, ...rest }: Readonly<DocumentTypeSelectProps>) {
  const { data, refetch } = useGetListDocumentTypeQuery<{
    data: { data: { id: number; value: string }[] };
  }>({ country });

  const options = data?.data?.map((documentType) => ({
    value: documentType.value,
    label: documentType.value,
  }));

  useEffect(() => {
    if (country) {
      refetch();
    }
    // eslint-disable-next-line
  }, [country]);
  return (
    <Select
      options={options}
      {...rest}
      handleChange={(value) => {
        rest.handleChange(value ?? '');
      }}
    />
  );
}
